import { HomeModernIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

type KeptEquipmentPhotoProps = {
  size?: 'small' | 'medium';
};

export default function KeptEquipmentPhoto({
  size = 'medium'
}: KeptEquipmentPhotoProps) {
  const classes = clsx(
    'flex shrink-0 items-center justify-center bg-gray-100',
    size === 'small' && 'h-8 w-12 rounded-sm',
    size === 'medium' && 'h-14 w-20 rounded-md'
  );

  const iconClasses = clsx(
    'text-gray-400',
    size === 'small' && 'h-5 w-5',
    size === 'medium' && 'h-8 w-8'
  );

  return (
    <div className={classes}>
      <HomeModernIcon className={iconClasses} />
    </div>
  );
}
